<template>
  <div id="app">
    <Header/>
    <transition name="loader-animation" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <ProgressBar :show-loader="showLoader" :loader-style="loaderStyle" />
    </transition>

    <transition name="page-transition" mode="out-in" appear>
      <div :class="{'inner-container': $route.path !== '/'}">
        <router-view></router-view>
      </div>
    </transition>

    <Footer/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Header from '@/components/Parts/Header.vue';
import Footer from '@/components/Parts/Footer.vue';
import ProgressBar from '@/components/Parts/ProgressBar.vue';

export default {
  components: {
    Header,
    Footer,
    ProgressBar,
  },
  data() {
    return {
      showLoader: true,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      loadingProgress: 'loadingProgress',
    }),

    loaderStyle() {
      return `width: ${this.loadingProgress}%;`;
    },
  },
  watch: {
    // watch the value of isLoading and once it's false hide the loader
    isLoading(val) {
      if (val == false) {
        setTimeout(() => {
          this.showLoader = false;
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  &, button, input, select, textarea {
    font-family: zen-old-mincho, serif;
    font-feature-settings: "palt";
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.07em;
  }
  background: $background;
  background-color: $background;

  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.inner-container {
  flex: 1;
}
</style>